var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Banner, FlexBox, Modal, ModalFoot, ModalHead, Page, TabsWithContent, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import noop from 'lodash/noop';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { LanguageCustomizationList } from 'components/settings/components/sections/satisfaction/components/DixaMessengerCSAT/page/components/LanguageCustomizationList';
import { MessengersList } from 'components/settings/components/sections/satisfaction/components/DixaMessengerCSAT/page/components/MessengersList';
import { hasFeature } from 'components/shared/featureFlag';
import { GlobalCsatSwitch } from '../../common/GlobalCsatSwitch';
export var DixaMessengerCsatSettingTabs;
(function (DixaMessengerCsatSettingTabs) {
    DixaMessengerCsatSettingTabs["Messengers"] = "Messengers";
    DixaMessengerCsatSettingTabs["LanguageLevelCustomizations"] = "Language customizations";
})(DixaMessengerCsatSettingTabs || (DixaMessengerCsatSettingTabs = {}));
class DixaMessengerPageBase extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { confirmationModal: { isOpen: false, context: null } };
    }
    handleMessengerStatusChange(change) {
        if (this.statusHasChangedToDeActive(change)) {
            this.openConfirmationModal(change);
        }
        else {
            this.props.onMessengerStatusChange(change);
        }
    }
    handleConfirmedAccountStatusChange() {
        const { confirmationModal } = this.state;
        if (confirmationModal.context) {
            this.props.onMessengerStatusChange(confirmationModal.context);
        }
        this.closeConfirmationModal();
    }
    openConfirmationModal(context) {
        this.setState({ confirmationModal: { isOpen: true, context: context } });
    }
    closeConfirmationModal() {
        this.setState({ confirmationModal: { isOpen: false, context: null } });
    }
    statusHasChangedToDeActive(change) {
        return change.newStatus === false;
    }
    render() {
        const { userHasDixaMessengerCSAT } = this.props;
        const tabsDefinition = Object.values(DixaMessengerCsatSettingTabs).map((tabName) => ({
            id: tabName,
            label: tabName,
        }));
        const notAllowedToBeDisabledLanguages = [];
        if (this.props.defaultLanguage) {
            notAllowedToBeDisabledLanguages.push(this.props.defaultLanguage);
        }
        const onGlobalCsatToggle = userHasDixaMessengerCSAT
            ? this.props.onGlobalStatusChange
            : noop;
        const messengerListIsDisabled = !this.props.isMessengerCsatSetup || !userHasDixaMessengerCSAT;
        const languageCustomizationIsDisabled = !this.props.isMessengerCsatSetup || !userHasDixaMessengerCSAT;
        return (_jsxs(_Fragment, { children: [_jsxs(Page.Section, Object.assign({ callout: _jsx(GlobalCsatSwitch, { channel: "messenger", onChange: onGlobalCsatToggle, isActive: this.props.userHasDixaMessengerCSAT &&
                            this.props.isMessengerCsatActive, disabled: !this.props.userHasDixaMessengerCSAT }) }, { children: [!userHasDixaMessengerCSAT && (_jsx(Banner, { variant: "announcement", headline: "Upgrade plan to Advanced or Unlimited", description: _jsx("span", { children: "Upgrade your plan to use a Customer satisfaction survey for your messenger. Get in touch with your account manager for more information." }) })), _jsxs(TabsWithContent, Object.assign({ initiallySelectedTabId: this.props.initiallyActiveTab, tabs: tabsDefinition }, { children: [_jsx(MessengersList, { messengers: this.props.existingMessengers, onStatusChange: this.handleMessengerStatusChange, isLoading: this.props.isLoadingMessengersList, disabled: messengerListIsDisabled }), this.props.existingMessengers.length > 0 ? (_jsx(LanguageCustomizationList, { languages: this.props.languages, onEdit: this.props.onLanguageEditRequest, onLanguageStatusChange: this.props.onLanguageStatusChange, disabled: languageCustomizationIsDisabled, notAllowedToBeDisabledLanguages: notAllowedToBeDisabledLanguages })) : (_jsx(FlexBox, Object.assign({ justifyContent: "center", alignItems: "center" }, { children: "No active messengers found!" })))] }))] })), _jsxs(Modal, Object.assign({ isOpen: this.state.confirmationModal.isOpen, onClose: this.closeConfirmationModal }, { children: [_jsx(ModalHead, Object.assign({ title: "Are you sure you want to disable CSAT for this messenger?" }, { children: "This will not trigger a CSAT when conversations are closed." })), _jsx(ModalFoot, { confirmOnClick: this.handleConfirmedAccountStatusChange, cancelOnClick: this.closeConfirmationModal, confirmName: "Disable" })] }))] }));
    }
}
DixaMessengerPageBase.defaultProps = {
    initiallyActiveTab: DixaMessengerCsatSettingTabs.Messengers,
};
__decorate([
    boundMethod
], DixaMessengerPageBase.prototype, "handleMessengerStatusChange", null);
__decorate([
    boundMethod
], DixaMessengerPageBase.prototype, "handleConfirmedAccountStatusChange", null);
__decorate([
    boundMethod
], DixaMessengerPageBase.prototype, "closeConfirmationModal", null);
export const DixaMessengerPage = connect((state) => ({
    userHasDixaMessengerCSAT: hasFeature(state, 'csat-for-dixa-messenger'),
}))(DixaMessengerPageBase);
